import userApi from '_api/user'
import { getUserInfo, setUserInfo as saveUserInfo } from '_utils/localData'
import { useEffect, useMemo, useState } from 'react'

export const useShareUserInfo = (groupDetail) => {
  const [userInfo, setCurrentUserInfo] = useState(getUserInfo())

  useEffect(() => {
    const syncUserInfo = async () => {
      try {
        const { msgResp } = await userApi.getUser()
        saveUserInfo(msgResp)
        setCurrentUserInfo(msgResp)
      } catch (err) {
        console.error('Failed to sync user info:', err)
      }
    }

    if (userInfo?.id && !userInfo?.groups) {
      syncUserInfo()
    }
  }, [userInfo])

  const userInGroup = useMemo(
    () =>
      userInfo?.groups?.find(
        (group) => group.gid === groupDetail?.group?.id && group.uid === userInfo?.id
      ),
    [userInfo, groupDetail?.group?.id]
  )

  const setUserInfo = (data) => {
    saveUserInfo(data)
    setCurrentUserInfo(data)
  }

  return {
    userInfo,
    setUserInfo,
    userInGroup,
  }
}
